import { isEmpty, first } from 'underscore';
import { getDomain } from '@bingads-webui/url-util';
import { isEmptyUrl } from '@bingads-webui-campaign-react/url-input-fluent';

export const getFinalUrlCardSummaryDetails = (i18n, finalUrls) => (isEmptyUrl(finalUrls) ? i18n.getString(_TL_('No URL')) : first(finalUrls));

export const getFinalUrlWithPath = (finalUrls, path1, path2) => {
  const finalUrlDomain = getDomain(first(finalUrls)) || 'www.example.com';
  return !isEmpty(path1) && !isEmpty(path2) ? `${finalUrlDomain}/${path1}/${path2}` : finalUrlDomain;
};

export const getAdvancedUrlOptionsCardSummaryDetails = (i18n, finalUrls, path1, path2, mobileFinalUrls) => {
  const finalUrl = first(finalUrls);
  const mobileFinalUrl = first(mobileFinalUrls);

  let displayUrl = '';
  if (!isEmpty(path1)) {
    const finalUrlDomain = getDomain(finalUrl) || 'www.example.com';
    displayUrl = `${finalUrlDomain}/${path1}`;
    if (!isEmpty(path2)) {
      displayUrl = `${displayUrl}/${path2}`;
    }
  }
  const noDisplayUrl = isEmpty(displayUrl);
  const noMboileUrl = isEmpty(mobileFinalUrl);

  if (noDisplayUrl && noMboileUrl) {
    return i18n.getString(_TL_('No settings applied'));
  }

  const displayUrlDetails = `${i18n.getString(_TL_('Display URL'))}: ${displayUrl}`;
  const mobileUrlDetails = `${i18n.getString(_TL_('Mobile URL'))}: ${mobileFinalUrl}`;

  return `${noDisplayUrl ? '' : displayUrlDetails}${noDisplayUrl || noMboileUrl ? '' : '; '}${noMboileUrl ? '' : mobileUrlDetails}`;
};
